export enum EntityMergeMode {
  REPLACE = 'replace',
  MERGE = 'merge'
}